import { useState } from "react";
import TextField from "../Reusable/TextInput";
//@ts-ignore
import { tw } from "@careinfo/tailwind";
const RoleForm = (props: any) => {
  const {
    selectedUserPermissions,
    register,
    errors,
    setSelectedPermission,
    Permissions,
  } = props;
  const [allselected, setallSelected] = useState(false);
  function extractCodeNames(obj) {
    let codeNames = [];

    for (const key in obj) {
      if (Array.isArray(obj[key])) {
        // If the value is an array, iterate through it
        obj[key].forEach((item) => {
          if (item.codeName) {
            codeNames.push(item.codeName);
          }
        });
      } else if (typeof obj[key] === "object" && obj[key] !== null) {
        // If the value is an object, recurse
        codeNames = codeNames.concat(extractCodeNames(obj[key]));
      }
    }

    return codeNames;
  }

  const allCodeNames = extractCodeNames(Permissions);

  const handleCheckUnchecedPermission = (codeName: string) => {
    const index = selectedUserPermissions.indexOf(codeName);
    if (index === -1) {
      // Element not found, so append it
      selectedUserPermissions.push(codeName);
    } else {
      // Element found, so delete it
      selectedUserPermissions.splice(index, 1);
    }
    setSelectedPermission([...selectedUserPermissions]);
  };

  const handlecheckedallPermission = (allCodeNames: any) => {
    if (
      Array.isArray(selectedUserPermissions) &&
      selectedUserPermissions.length !== allCodeNames.length
    ) {
      setSelectedPermission(allCodeNames);
      setallSelected(true);
    } else {
      setSelectedPermission([]);
      setallSelected(false);
    }
  };

  const handlecheckedgroupPermission = (
    topkey: any,
    secondkey: any,
    checked: boolean
  ) => {
    const codeNames = Permissions[topkey][secondkey]?.map(
      (item) => item.codeName
    );
    codeNames.forEach((codeName) => {
      const index = selectedUserPermissions.indexOf(codeName);
      if (index > -1 && !checked) {
        selectedUserPermissions.splice(index, 1);
      } else if (index === -1) {
        // If codeName does not exist, add it
        selectedUserPermissions.push(codeName);
      }
    });
    setSelectedPermission([...selectedUserPermissions]);
  };

  const checkIsSelected = (codeName: string) => {
    const index = selectedUserPermissions.indexOf(codeName);
    if (index === -1) {
      return false;
    }
    return true;
  };

  return (
    <div className={tw`px-4`}>
      <TextField
        label={"Name"}
        register={register("role")}
        errors={errors?.role}
      />
      <div
        className={tw`flex relative top-10 justify-end items-center gap-x-2`}
      >
        <label htmlFor={""} className={tw`cursor-pointer capitalize`}>
          Select all
        </label>
        <input
          type="checkbox"
          checked={allselected}
          onChange={(e) => handlecheckedallPermission(allCodeNames)}
          className={tw`appearance-none w-4 h-4 border-[1px] border-gray-500 mt-1 shrink-0 checked:bg-primary checked:border-0 mr-2 cursor-pointer`}
        />
      </div>
      {Permissions &&
        Object.keys(Permissions)?.map((topkey: string, index: number) => (
          <div className={tw`my-6`} key={index}>
            <h2 className={tw`uppercase font-bold text-gray-400 mt-6`}>
              {topkey}
            </h2>
            <div className={tw`h-[1px] w-full bg-gray-400 rounded`} />
            <div
              className={tw`grid xl:grid-cols-3 lg:grid-cols-3 md:grid-cols-2 sm:grid-rows-1 gap-x-3  gap-y-10`}
            >
              {Object.keys(Permissions[topkey])?.map(
                (secondkey: string, index: number) => (
                  <div className={tw`my-6`} key={index}>
                    <div className={tw`py-5 shadow-md p-6`}>
                      <details className={tw`group`}>
                        <summary
                          className={tw`flex justify-between items-center font-medium cursor-pointer list-none`}
                        >
                          <div className={tw`flex gap-x-2 `}>
                            <span
                              className={tw`uppercase font-bold text-gray-400  `}
                            >
                              {secondkey}
                            </span>
                            <input
                              type="checkbox"
                              // checked={}
                              onChange={(event) =>
                                handlecheckedgroupPermission(
                                  topkey,
                                  secondkey,
                                  event.target.checked
                                )
                              }
                              className={tw`appearance-none w-4 h-4 border-[1px] border-gray-500  shrink-0 checked:bg-primary checked:border-0 mr-2 cursor-pointer`}
                              id={secondkey}
                            />
                          </div>
                          <span
                            className={tw`transition group-open:rotate-180`}
                          >
                            <svg
                              fill="none"
                              height="24"
                              shapeRendering="geometricPrecision"
                              stroke="currentColor"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              strokeWidth="1.5"
                              viewBox="0 0 24 24"
                              width="24"
                            >
                              <path d="M6 9l6 6 6-6"></path>
                            </svg>
                          </span>
                        </summary>
                        <div className={tw`py-6`}>
                          {Permissions[topkey][secondkey]?.map(
                            (item: any, index: number) => (
                              <div
                                key={index}
                                className={tw`flex justify-between items-center gap-6`}
                              >
                                <label
                                  htmlFor={item?.codeName}
                                  className={tw`cursor-pointer capitalize`}
                                >
                                  {item?.name}
                                </label>
                                <input
                                  type="checkbox"
                                  checked={checkIsSelected(item?.codeName)}
                                  onChange={() =>
                                    handleCheckUnchecedPermission(
                                      item?.codeName
                                    )
                                  }
                                  className={tw`appearance-none w-4 h-4 border-[1px] border-gray-500 mt-1 shrink-0 checked:bg-primary checked:border-0 mr-2 cursor-pointer`}
                                  id={item?.codeName}
                                />
                              </div>
                            )
                          )}
                        </div>
                      </details>
                    </div>
                  </div>
                )
              )}
            </div>
          </div>
        ))}
      {/* </div> */}
    </div>
  );
};

export default RoleForm;
